
import React from 'react';

const Logo: React.FC<{ size?: number; className?: string }> = ({ size = 40, className = "" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 120 120" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <linearGradient id="sapphire_vault_gradient" x1="15" y1="30" x2="105" y2="90" gradientUnits="userSpaceOnUse">
        <stop stopColor="#0f172a" />
        <stop offset="1" stopColor="#1e293b" />
      </linearGradient>
      
      <linearGradient id="clasp_gold_premium" x1="50" y1="32" x2="70" y2="82" gradientUnits="userSpaceOnUse">
        <stop stopColor="#fbbf24" />
        <stop offset="1" stopColor="#d97706" />
      </linearGradient>

      <filter id="gold_pulse" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur stdDeviation="3" result="blur" />
        <feComposite in="SourceGraphic" in2="blur" operator="over" />
      </filter>
    </defs>

    {/* Wallet Chassis */}
    <rect x="15" y="32" width="90" height="68" rx="14" fill="url(#sapphire_vault_gradient)" />
    
    {/* The 'E' Integration */}
    <path d="M28 48H45" stroke="white" strokeWidth="4" strokeLinecap="round" strokeOpacity="0.3" />
    <path d="M28 60H42" stroke="white" strokeWidth="4" strokeLinecap="round" strokeOpacity="0.25" />
    <path d="M28 72H38" stroke="white" strokeWidth="4" strokeLinecap="round" strokeOpacity="0.2" />
    <path d="M28 48V72" stroke="white" strokeWidth="4" strokeLinecap="round" strokeOpacity="0.25" />

    {/* The 'T' Clasp Integration */}
    <rect x="52" y="32" width="16" height="52" rx="4" fill="url(#clasp_gold_premium)" />
    <rect x="42" y="32" width="36" height="8" rx="2" fill="#fef3c7" />
    
    {/* Active Encryption Indicator */}
    <circle cx="60" cy="74" r="2.5" fill="#3b82f6" filter="url(#gold_pulse)" />

    <rect x="15" y="32" width="90" height="68" rx="14" fill="white" fillOpacity="0.05" />

    <text 
      x="60" 
      y="118" 
      textAnchor="middle" 
      fill="#0f172a" 
      fontSize="10" 
      fontWeight="900" 
      style={{ letterSpacing: '0.4em', textTransform: 'uppercase' }}
    >
      SecureTrack
    </text>
  </svg>
);

export default Logo;
